// The web bundle's build: the image's commit (`BUILD_SHA`, deploy/pipeline/Dockerfile) or the local
// git commit, set by vite.config.ts. Also on <html data-build> so it is visible in the page.
declare const __BUILD_SHA__: string | undefined;

export const BUILD_SHA: string =
  typeof __BUILD_SHA__ === "string" && /^[A-Za-z0-9._-]{1,64}$/.test(__BUILD_SHA__) ? __BUILD_SHA__ : "dev";

export function markBuild(doc: Document = document) {
  doc.documentElement.dataset.build = BUILD_SHA;
}
